// ============================================================
// WINNERSAURUS — Supabase Client
//
// This file creates the connection between your React site
// and your Supabase database. Import { supabase } from this
// file anywhere you need database or auth access.
// ============================================================

import { createClient } from '@supabase/supabase-js';

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey  = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error(
    'Missing Supabase environment variables. ' +
    'Check REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in Vercel settings.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseKey);
